import React from "react";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Drawer, Image } from "@mantine/core";
import { BiMenuAltRight } from "react-icons/bi";
import { IoShieldCheckmarkOutline, IoSettingsOutline } from "react-icons/io5";
import { MdLogout } from "react-icons/md";
import { BsBarChart } from "react-icons/bs";
import { GoHome } from "react-icons/go";
import { RiExchangeDollarFill } from "react-icons/ri";
import Logo from "../assets/Logo.png";

import Context from "../context/Context";

const DashboardSideBar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = React.useState(false);
  const context = useContext(Context);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const dashboardNavigation = [
    {
      Name: "Home",
      Route: "/",
      icon: <GoHome className={`text-[26px]`} />,
    },
    {
      Name: "Security Tokens",
      Route: "/tokens",
      icon: <IoShieldCheckmarkOutline className={`text-[24px]`} />,
    },
    {
      Name: "Token Exchange",
      Route: "/exchange",
      icon: <BsBarChart className={`text-[24px]`} />,
    },
    {
      Name: "Transactions",
      Route: "/transactions",
      icon: <RiExchangeDollarFill className="text-[26px]" />,
    },
  ];

  return (
    <div className="bg-white fixed md:relative md:w-auto w-full z-20 shadow-xl font-manrope">
      <div className="w-full md:h-full flex justify-between items-center md:flex-col md:p-5 p-4">
        <div className="md:flex flex-col hidden justify-start items-center">
          {/* Logo */}
          <Link to={"/"} className="relative w-[102px] h-[50px]">
            <Image src={Logo} alt="" className="object-contain" />
          </Link>

          {/* NavItems */}
          <div className="flex justify-center items-center flex-col gap-4 mt-12">
            {dashboardNavigation?.map((item: any, index: number) => {
              return (
                <Link
                  key={index}
                  to={item.Route}
                  className={`w-[170px] px-3 py-4 flex items-center justify-start gap-2 group  text-sm font-medium rounded-xl ${
                    item.Route === location.pathname
                      ? "text-white bg-gradient-to-b from-brand-main to-brand-secondary"
                      : " hover:text-white hover:bg-gradient-to-b from-brand-main to-brand-secondary"
                  }`}
                >
                  {item.icon}
                  {item.Name}
                </Link>
              );
            })}
          </div>
        </div>
        <div className="w-full md:flex hidden flex-col items-center justify-start gap-2">
          <Link
            to={"/settings"}
            className={`w-[170px] px-3 py-4 flex items-center justify-start gap-2 group  text-sm font-medium rounded-xl 
                ${
                  "/settings" === location.pathname
                    ? "text-white bg-gradient-to-b from-brand-main to-brand-secondary"
                    : " hover:text-white hover:bg-gradient-to-b from-brand-main to-brand-secondary"
                }`}
          >
            <IoSettingsOutline className="text-[24px]" />
            Setting
          </Link>

          <a
            href="#"
            className={`w-[170px] px-3 py-4 flex items-center justify-start gap-2 group  text-sm font-medium rounded-xl 
                ${
                  "/#" === location.pathname
                    ? "text-white bg-gradient-to-b from-brand-main to-brand-secondary"
                    : " hover:text-white hover:bg-gradient-to-b from-brand-main to-brand-secondary"
                }`}
            onClick={(event) => {
              context.handlers.logout();
              event.preventDefault();
            }}
          >
            <MdLogout className="text-[24px]" />
            <span>Logout</span>
          </a>
        </div>
        {/* For Phone */}
        {/* Logo */}
        <Link
          to={"/"}
          className="relative md:hidden inline-block w-[80px] h-[40px] "
        >
          <Image src={Logo} alt="" className="object-contain" />
        </Link>
        <BiMenuAltRight
          onClick={toggleDrawer}
          className="text-[24px] md:hidden inline-block"
        />
      </div>

      <Drawer
        opened={isOpen}
        onClose={toggleDrawer}
        position="left"
        size="100%"
      >
        <div className="w-full h-full flex justify-between items-center flex-col overflow-auto gap-4 p-4">
          <div className="w-full flex justify-start items-center flex-col gap-6">
            {/* Logo */}
            <Link to={"/"} className="relative w-[102px] h-[50px] ">
              <Image src={Logo} alt="" className="object-contain" />
            </Link>

            {/* NavItems */}
            <div className="w-full flex justify-center items-center flex-col gap-4 mt-12">
              {dashboardNavigation?.map((item: any, index: number) => {
                return (
                  <Link
                    onClick={toggleDrawer}
                    key={index}
                    to={item.Route}
                    className={`w-full px-3 py-4 flex items-center justify-start gap-2 group  text-sm font-medium rounded-xl ${
                      item.Route === location.pathname
                        ? "text-white bg-gradient-to-b from-brand-main to-brand-secondary"
                        : " hover:text-white hover:bg-gradient-to-b from-brand-main to-brand-secondary"
                    }`}
                  >
                    {item.icon}
                    {item.Name}
                  </Link>
                );
              })}
            </div>
            <div className="w-full flex flex-col items-center justify-start gap-2">
              <Link
                to={"/settings"}
                onClick={toggleDrawer}
                className={`w-full px-3 py-4 flex items-center justify-start gap-2 group  text-sm font-medium rounded-xl ${
                  "/settings" === location.pathname
                    ? "text-white bg-gradient-to-b from-brand-main to-brand-secondary"
                    : " hover:text-white hover:bg-gradient-to-b from-brand-main to-brand-secondary"
                }`}
              >
                <IoSettingsOutline className="text-[24px]" />
                Setting
              </Link>

              <a
                href="#"
                className={`w-full px-3 py-4 flex items-center justify-start gap-2 group  text-sm font-medium rounded-xl ${
                  "/settings" === location.pathname
                    ? "text-white bg-gradient-to-r from-brand-tartary to-brand-secondary"
                    : " hover:text-white hover:bg-gradient-to-r from-brand-tartary to-brand-secondary"
                }`}
                onClick={(event) => {
                  context.handlers.logout();
                  event.preventDefault();
                }}
              >
                <MdLogout className="text-[24px]" />
                <span>Logout</span>
              </a>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default DashboardSideBar;
